import React from 'react'
import AnimBox from 'components/AnimBox'
import { Info } from '@mui/icons-material'
import { Typography } from '@mui/material'
import useStyles from './styles'

export interface ITabPlaceholderProps {
  title?: React.ReactNode
  icon?: React.ReactNode
  text?: React.ReactNode
}

function TabPlaceholder(props: ITabPlaceholderProps) {
  const { classes } = useStyles()
  const { icon = (<Info />), title = 'Nothing here', text } = props

  return (
    <AnimBox delay={300}>
      <div className={classes.container}>
        <div className={classes.icon}>
          {icon}
        </div>

        <div className={classes.title}>
          {title}
        </div>

        <Typography variant="body1" className={classes.text}>
          {text}
        </Typography>
      </div>
    </AnimBox>
  )
}

export default React.memo(TabPlaceholder)
